/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "c9a5d88a60f00116107cfca5e736050137ea4dae";
